import React, { useState, useEffect, useMemo } from "react";
import CreaUsuario from "./CreaUsuario";
import EditarUsuario from "./EditarUsuario";
import EliminarUsuario from "./EliminarUsuario";

function InfoUsuarios() {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const URL = "https://suadesarrollo.azurewebsites.net/api/ObtenerUsuarios";

  const tipoUsuarioMap = {
    1: "Admin",
    2: "Institución",
    3: "Evaluador",
    4: "Junta",
  };

  useEffect(() => {
    const fetchUsers = async () => {
      const username = "BasicAuth@icontec.org";
      const password = "yQLzqmR7eZSuAmQZUqhY";
      const basicAuth = btoa(`${username}:${password}`);

      try {
        const response = await fetch(URL, {
          headers: {
            Authorization: `Basic ${basicAuth}`,
          },
        });

        if (!response.ok) {
          throw new Error(`Error HTTP: ${response.status}`);
        }

        const data = await response.json();
        setUsers(data);
      } catch (err) {
        setError(err.message || "Error cargando usuarios");
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const filteredUsers = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return users;
    return users.filter((u) => u.nombre.toLowerCase().includes(query));
  }, [search, users]);

  if (loading) {
    return <div className="text-center">Cargando usuarios...</div>;
  }

  if (error) {
    return <div className="alert alert-danger">{error}</div>;
  }

  return (
    <div className="container">
      <div className="text-center">
        <div className="container-fluid">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Información Usuarios
              </h6>
            </div>

            <div className="card-body">
              <CreaUsuario />
              <br />

              <div className="table-responsive">
                <input
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  type="text"
                  placeholder="Buscar por nombre"
                  className="form-control mb-3"
                />

                <table
                  className="table table-bordered"
                  id="dataTable"
                  width="100%"
                >
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Nombre</th>
                      <th>Correo Electrónico</th>
                      <th>Tipo de Usuario</th>
                      <th>Institución Id</th>
                      <th>Editar</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredUsers.length > 0 ? (
                      filteredUsers.map((item) => (
                        <tr key={item.id}>
                          <td>{item.id}</td>
                          <td>{item.nombre}</td>
                          <td>{item.correo_Electronico}</td>
                          <td>
                            {tipoUsuarioMap[item.tipo_Usuario] ||
                              item.tipo_Usuario}
                          </td>
                          <td>{item.institucionId}</td>
                          <td>
                            <EditarUsuario
                              idUsuario={item.id}
                              nombre={item.nombre}
                              correo={item.correo_Electronico}
                              tipo={item.tipo_Usuario}
                              contrasena={item.contrasena}
                              institucionId={item.institucionId}
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center">
                          No se encontraron usuarios
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InfoUsuarios;
